// Single-listener Esc-key stack: only the top-most modal's handler runs.
// Avoids the "stacked modals all close on one Esc" bug when each
// independently registers `window.addEventListener('keydown', ...)`.

const stack: Array<() => void> = [];

function onKey(e: KeyboardEvent): void {
  if (e.key !== 'Escape') return;
  const top = stack[stack.length - 1];
  if (!top) return;
  e.stopPropagation();
  top();
}

export function pushEscape(handler: () => void): () => void {
  if (stack.length === 0) window.addEventListener('keydown', onKey);
  stack.push(handler);
  return () => {
    const i = stack.lastIndexOf(handler);
    if (i >= 0) stack.splice(i, 1);
    if (stack.length === 0) window.removeEventListener('keydown', onKey);
  };
}

export function _resetEscapeStackForTests(): void {
  stack.length = 0;
  window.removeEventListener('keydown', onKey);
}
